module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/process/process-04-aa8869f1fcbdc9c1d72503678c07b01e.svg";